import { http, uploadFile } from '@/utils/axios'
import axios from 'axios'
import qs from 'qs'


/**
 * @msg: 获取办学形式
 */
export function getEducationType () {
  return http({
    url: http.baseUrl('courseWare/getEducationType'),
    method: 'get',
    params: http.params({

    })
  })
}


/**
 * @msg: 通过uid获取用户
 */
export function getUserByUid (uid) {
  return http({
    url: http.baseUrl('elUser/getUserByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}

/**
 * @msg: 通过uid获取机构
 */
export function getSchoolByUid (uid) {
  return http({
    url: http.baseUrl('elSchool/getSchoolByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}


/**
 * @msg: 获取机构列表
 */
export function getOrganLists () {
  return http({
    url: http.baseUrl('elSchool/getList'),
    method: 'post',
    params: http.params({

    })
  })
}


/**
 * @msg: 上传封面
 */
export function addCover (file) {
  return http({
    url: http.baseUrl('courseDetail/addCover'),
    method: 'post',
    params: http.params(file),
    data:file
  })
}


/**
 * @msg: 获取基础课程列表
 */
export function getCourseList ({courseName='',educationTypeCodes=''}) {
  return http({
    url: http.baseUrl('courseWare/getCourseList'),
    method: 'get',
    params: http.params({
      courseName,
      educationTypeCodes
    })
  })
}



/**
 * @msg: 添加/修改课程
 */
export function addCourseDetail (obj) {
  return http({
    url: http.baseUrl('courseDetail/addCourseDetail'),
    method: 'post',
    params: http.params(obj),
    data:obj
  })
}

